export const state = {
	allTags: [],
	teamTags: [],
	playerTags: [],
	chartTags: [],
	widgetTags: [],
	statTags: [],
};
